/**
 * Curated list of scheduling-intent trigger words.
 *
 * The typeahead activates when the user types characters that prefix-match
 * (or fuzzy-match as fallback) against this list. Sorted alphabetically.
 *
 * Maintained as a static config for easy updates. Review after user testing
 * to prune words that cause too many false positives.
 */
export const TRIGGER_WORDS = [
  "Arrange",
  "Block",
  "Book",
  "Breakfast",
  "Catch up",
  "Check in",
  "Coffee",
  "Connect",
  "Coordinate",
  "Dinner",
  "Drinks",
  "Find time",
  "Get together",
  "Grab",
  "Hold",
  "Invite",
  "Lunch",
  "Make",
  "Meet",
  "Organize",
  "Plan",
  "Reschedule",
  "Schedule",
  "Set up",
  "Sync",
] as const;

/**
 * Base slash commands shown in the `/` dropdown.
 *
 * Each maps to aliases from the full TRIGGER_WORDS list. Typing `/meet` or
 * `/coffee` matches the "Schedule" entry. The typeahead still recognizes all
 * 26 trigger words when typed directly into the textarea.
 */
export interface SlashScheduleCommand {
  /** The canonical trigger word used when this entry is selected. */
  name: string;
  description: string;
  /** Other trigger words that should match this entry during `/` filtering. */
  aliases: readonly string[];
}

export const SLASH_SCHEDULE_COMMANDS: SlashScheduleCommand[] = [
  {
    name: "Schedule",
    description: "Schedule a meeting or event",
    aliases: [
      "Arrange",
      "Book",
      "Breakfast",
      "Catch up",
      "Check in",
      "Coffee",
      "Connect",
      "Coordinate",
      "Dinner",
      "Drinks",
      "Find time",
      "Get together",
      "Grab",
      "Hold",
      "Lunch",
      "Make",
      "Meet",
      "Organize",
      "Plan",
      "Set up",
      "Sync",
    ],
  },
  {
    name: "Block",
    description: "Block time on your calendar",
    aliases: [],
  },
  {
    name: "Invite",
    description: "Send a meeting invite",
    aliases: [],
  },
  {
    name: "Reschedule",
    description: "Reschedule an existing event",
    aliases: [],
  },
];
